/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import * as animationData from 'assets/animations/info.json';
import Modal from 'components/Modal';
import Translate from 'components/Translate';
import './styles.scss';
import { useMemo } from 'react';
import useLiterals from 'utils/hooks/useLiterals';
import Button from 'components/UI/Button';

function ErrorModal({
  title = '',
  description = '',
  children = null,
  position = 'end',
  onClose,
}) {
  const literals = useLiterals('errors');

  const message = useMemo(() => {
    if (!description || typeof description === 'boolean') {
      return literals.default;
    }
    if (typeof description === 'string') {
      return literals[description] || description;
    }
    if (typeof description === 'object') {
      if (description?.data?.error && typeof description.data.error === 'string') {
        return literals[description.data.error] || description.data.error;
      }
    }
    if (description instanceof Error) {
      return description?.message || literals.default;
    }
    return literals.default;
  }, [description]);

  return (
    <Modal
      className='feedback-modal'
      position={position}
      onClose={onClose}
    >
      <div className='text-center'>
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          height={90}
          width={90}
        />
        <h3 className='mt-1'>
          {title || literals.error}
        </h3>
        {message && (
          <Translate component='h3' className='text-neutral-500 font-normal mt-6' literal={message} />
        )}
        {children || <Button className='mt-6' onClick={onClose}>{literals.common.close}</Button>}
      </div>
    </Modal>
  );
}

ErrorModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  position: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default ErrorModal;
